import { usePlatformStore } from "../store";

export function useIsEnrollmentClosed() {
  const isEnrollmentClosed = usePlatformStore(
    (s) => s.featureFlags.isEnrollmentClosed
  );
  return isEnrollmentClosed ?? false;
}
